import styled from 'styled-components';
import { VL_BLACK, WHITE } from '../../utils/colours';

export const FooterContainer = styled.footer`
    background: ${({ $isVideoloft }) => $isVideoloft ? 'linear-gradient(90deg, #EAFFFF 0%, #C2C8FF 100%)': VL_BLACK(75)};
    color: ${({ $isVideoloft }) => $isVideoloft ? VL_BLACK() : WHITE()};
    padding: 20px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    min-height: 78px;
`;

FooterContainer.displayName = 'FooterContainer';

export const LogoImage = styled.img`
    max-width: 200px;
    max-height: 80px;
    margin: auto;
    margin-bottom: 20px;
    display: block;
`;

LogoImage.displayName = 'LogoImage';

export const LinksRow = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
`;

LinksRow.displayName = 'LinksRow';

export const FooterLink = styled.a`
    font-size: 14px;
    font-weight: 100;
    margin: 0 15px;
    text-decoration: underline;
    text-align: center;
`;

FooterLink.displayName = 'FooterLink';

export const MarketingHeaderContainer = styled.div`
    opacity: ${({ $isVisible }) => $isVisible ? 1 : 0};
    transition: opacity 0.6s ease-in-out;
`;

export const MarketingContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin: 10px 0;
    align-items: center;
`;
